import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "./baseQuery";

export const ticketApi = createApi({
  reducerPath: "ticketApi",
  baseQuery: baseQueryWithReauth, 
  endpoints: (builder) => ({
    getTickets: builder.query({
      query: (params) => ({
        url: "ticket/",
        params,
      }),
    }),
    getTicketById: builder.query({
      query: (ticketId) => ({
        url: `ticket/${ticketId}`,
      }),
    }),
    createTicket: builder.mutation({
      query: (newTicket) => ({
        url: "ticket",
        method: "POST",
        body: newTicket,
      }),
    }),
    updateTicket: builder.mutation({
      query: ({ id, updatedTicket }) => ({
        url: `ticket/${id}`,
        method: "PUT",
        body: updatedTicket,
      }),
    }),
    duplicateTicket: builder.mutation({
      query: (id) => ({
        url: `ticket/duplicate/${id}`,
        method: "POST",
      }),
    }),
    deleteTicket: builder.mutation({
      query: (id) => ({
        url: `ticket/${id}`,
        method: "DELETE",
      }),
    }),
    getDosages: builder.query({
      query: (ticketId) => ({
        url: `dosage/ticket/${ticketId}`,
      }),
    }),
  }),
});

export const {
  useGetTicketsQuery,
  useGetTicketByIdQuery,
  useCreateTicketMutation,
  useDuplicateTicketMutation,
  useUpdateTicketMutation,
  useDeleteTicketMutation,
  useGetDosagesQuery,
} = ticketApi;